module.exports = __webpack_public_path__ + "static/media/RSD01.ef4d3c17.jpeg";